import { GlobalEmailTypes } from '../constants-types/Enums';

export class DefaultEmailSettingDescription {
    globalEmailTypeId: GlobalEmailTypes;
    globalEmailDescription: string;
}
